<template>
  <div class="bigchallenge-page">
    <div v-loading="loading">
      <main>
        <!-- 轮播 -->
        <div class="swiper">
          <div class="swiperBox" id="swiper">
            <el-carousel :height="swiperHeight">
              <el-carousel-item v-for="(item, index) in ppttrack" :key="index">
                <template v-if="item.type == 2">
                  <a :href="item.url" target="_blank">
                    <img
                      class="bannImage"
                      :src="item.image"
                      alt=""
                      @click="addUrl(item)"
                    />
                  </a>
                </template>
                <template v-else>
                  <img
                    class="bannImage"
                    :src="item.image"
                    alt=""
                    @click="addUrl(item)"
                  />
                </template>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>

        <!-- 大挑模块内容区域 - 统一外层包裹 -->
        <div class="bigchallenge-content-wrapper">
          <!-- 大挑模块标题 -->
          <div class="bigchallenge-title-section">
            <div class="bigchallenge-title-header">
              <div class="title-icon-wrapper">
                <i class="el-icon-trophy title-icon"></i>
              </div>
              <h2>挑战杯大学生课外学术科技作品竞赛</h2>
              <p class="title-subtitle">挑战自我 · 创新未来</p>
              <div class="title-decoration">
                <span class="decoration-line"></span>
                <span class="decoration-dot"></span>
                <span class="decoration-line"></span>
              </div>
            </div>
          </div>

          <!-- 主赛道模块 -->
        <div class="bigchallenge-modules">
          <div class="module-section main-track-section">
            <div class="module-header-wrapper">
              <div class="module-header">
                <div class="module-title-group">
                  <h2>主赛道</h2>
                  <p>MAIN TRACK</p>
                </div>
              </div>
              <div class="category-tabs">
                <div
                  :class="[
                    'category-tab',
                    { active: mainTrackSelectedCategory === 'all' }
                  ]"
                  @click="selectMainTrackCategory('all')"
                >
                  全部
                </div>
                <div
                  v-for="category in mainTrackCategories"
                  :key="category.id"
                  :class="[
                    'category-tab',
                    { active: mainTrackSelectedCategory === category.id }
                  ]"
                  @click="selectMainTrackCategory(category.id)"
                >
                  {{ category.name }}
                </div>
              </div>
            </div>
            <div class="files-grid" v-if="mainTrackFiles.length > 0">
              <div
                v-for="file in mainTrackFiles"
                :key="file.id"
                class="file-card"
                @click="viewFile(file)"
              >
                <div class="file-image">
                  <img 
                    v-if="file.cover || file.image" 
                    :src="file.cover || file.image" 
                    :alt="file.name" 
                    @error="handleImageError"
                  />
                  <div v-else class="image-placeholder">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                  <i class="ppt_tag-vip ppt_tag-vips"></i>
                </div>
                <div class="file-info">
                  <div class="file-tags" v-if="file.tag">
                    <span
                      v-for="(tag, index) in file.tag.split(',')"
                      :key="index"
                      class="file-tag"
                    >
                      {{ tag }}
                    </span>
                  </div>
                  <div class="file-content">
                    <div class="file-left">
                      <h3>{{ file.name }}</h3>
                    </div>
                    <div class="file-right">
                      <div class="file-stats">
                        <span class="stat-item">
                          <i class="iconfont iconaixin"></i>
                          {{ file.laud || 0 }}
                        </span>
                        <span class="stat-item">
                          <i class="iconfont iconai-eye"></i>
                          {{ file.pv || 0 }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="empty-state" v-else>
              <div class="empty-icon">
                <i class="el-icon-document"></i>
              </div>
              <p>暂无文件数据</p>
            </div>
            <!-- 分页 -->
            <div class="pagination-container">
              <el-pagination
                @current-change="handleMainTrackPageChange"
                :current-page="mainTrackPageNum"
                :page-size="pageSize"
                :total="mainTrackTotal || 0"
                layout="prev, pager, next"
                :pager-count="5"
                :hide-on-single-page="false"
                prev-text="上一页"
                next-text="下一页"
                background
              >
              </el-pagination>
            </div>
          </div>

          <!-- 专项赛道模块 -->
          <div class="module-section special-track-section">
            <div class="module-header-wrapper">
              <div class="module-header">
                <div class="module-title-group">
                  <h2>专项赛道</h2>
                  <p>SPECIAL TRACK</p>
                </div>
              </div>
              <div class="category-tabs">
                <div
                  :class="[
                    'category-tab',
                    { active: specialTrackSelectedCategory === 'all' }
                  ]"
                  @click="selectSpecialTrackCategory('all')"
                >
                  全部
                </div>
                <div
                  v-for="category in specialTrackCategories"
                  :key="category.id"
                  :class="[
                    'category-tab',
                    { active: specialTrackSelectedCategory === category.id }
                  ]"
                  @click="selectSpecialTrackCategory(category.id)"
                >
                  {{ category.name }}
                </div>
              </div>
            </div>
            <div class="files-grid" v-if="specialTrackFiles.length > 0">
              <div
                v-for="file in specialTrackFiles"
                :key="file.id"
                class="file-card"
                @click="viewFile(file)"
              >
                <div class="file-image">
                  <img 
                    v-if="file.cover || file.image" 
                    :src="file.cover || file.image" 
                    :alt="file.name" 
                    @error="handleImageError"
                  />
                  <div v-else class="image-placeholder">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                  <i class="ppt_tag-vip ppt_tag-vips"></i>
                </div>
                <div class="file-info">
                  <div class="file-tags" v-if="file.tag">
                    <span
                      v-for="(tag, index) in file.tag.split(',')"
                      :key="index"
                      class="file-tag"
                    >
                      {{ tag }}
                    </span>
                  </div>
                  <div class="file-content">
                    <div class="file-left">
                      <h3>{{ file.name }}</h3>
                    </div>
                    <div class="file-right">
                      <div class="file-stats">
                        <span class="stat-item">
                          <i class="iconfont iconaixin"></i>
                          {{ file.laud || 0 }}
                        </span>
                        <span class="stat-item">
                          <i class="iconfont iconai-eye"></i>
                          {{ file.pv || 0 }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="empty-state" v-else>
              <div class="empty-icon">
                <i class="el-icon-document"></i>
              </div>
              <p>暂无文件数据</p>
            </div>
            <!-- 分页 -->
            <div class="pagination-container">
              <el-pagination
                @current-change="handleSpecialTrackPageChange"
                :current-page="specialTrackPageNum"
                :page-size="pageSize"
                :total="specialTrackTotal || 0"
                layout="prev, pager, next"
                :pager-count="5"
                :hide-on-single-page="false"
                prev-text="上一页"
                next-text="下一页"
                background
              >
              </el-pagination>
            </div>
          </div>
        </div>
        </div>

        <!-- 用户评价轮播区域 -->
        <div class="reviews-section">
          <div class="reviews-container">
            <div class="reviews-header">
              <h2>用户评价</h2>
              <p>USER REVIEWS</p>
            </div>
            <div class="reviews-content">
              <vue-seamless-scroll
                :data="reviewData1"
                :class-option="reviewOption1"
                ref="reviewScroll1"
                class="review-scroll"
              >
                <ul>
                  <li
                    class="review-item"
                    v-for="(item, index) in reviewData1"
                    :key="'r1' + index"
                  >
                    <div class="review-avatar">
                      <img :src="item.avatar" alt="" />
                    </div>
                    <div class="review-content">
                      <div class="review-text">{{ item.content }}</div>
                      <div class="review-user">{{ item.username }}</div>
                    </div>
                  </li>
                </ul>
              </vue-seamless-scroll>
              <vue-seamless-scroll
                :data="reviewData2"
                :class-option="reviewOption2"
                ref="reviewScroll2"
                class="review-scroll"
              >
                <ul>
                  <li
                    class="review-item"
                    v-for="(item, index) in reviewData2"
                    :key="'r2' + index"
                  >
                    <div class="review-avatar">
                      <img :src="item.avatar" alt="" />
                    </div>
                    <div class="review-content">
                      <div class="review-text">{{ item.content }}</div>
                      <div class="review-user">{{ item.username }}</div>
                    </div>
                  </li>
                </ul>
              </vue-seamless-scroll>
            </div>
          </div>
        </div>

        <!-- 服务保障区域 -->
        <div class="itmentBox">
          <ul class="tment_ul clearfix">
            <li>
              <i class="iconfont iconbanquan"></i>
              <p class="decla_title">正版承诺</p>
              <p class="decla_intro">拒绝盗版，获设计师独家授权</p>
            </li>
            <li>
              <i class="iconfont iconbanquan1"></i>
              <p class="decla_title">版权保障 商用无忧</p>
              <p class="decla_intro">对全站所有模板均拥有商用授权</p>
            </li>
            <li class="last_item">
              <i class="iconfont icontiexinfuwu"></i>
              <p class="decla_title">全天候 贴心服务</p>
              <p class="decla_intro">
                发票支持，报销无忧<br />团队协作，院校会员可多人使用
              </p>
            </li>
          </ul>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "BigChallengePage",
  data() {
    return {
      ppttrack: [],
      screenWidth: document.body.clientWidth,
      swiperHeight: "625px",
      loading: false,

      // 用户评价数据
      reviewData1: [],
      reviewData2: [],

      // 分页
      pageSize: 8,

      // 主赛道数据
      mainTrackCategories: [],
      mainTrackFiles: [],
      mainTrackPageNum: 1,
      mainTrackTotal: 0,
      mainTrackSelectedCategory: null,

      // 专项赛道数据
      specialTrackCategories: [],
      specialTrackFiles: [],
      specialTrackPageNum: 1,
      specialTrackTotal: 0,
      specialTrackSelectedCategory: null
    };
  },
  computed: {
    ...mapState(["nav"]),
    reviewOption1() {
      return {
        step: 0.8,
        limitMoveNum: 0,
        hoverStop: true,
        direction: 2,
        openWatch: true,
        singleHeight: 0,
        singleWidth: 0,
        waitTime: 1500
      };
    },
    reviewOption2() {
      return {
        step: 0.8,
        limitMoveNum: 0,
        hoverStop: true,
        direction: 3,
        openWatch: true,
        singleHeight: 0,
        singleWidth: 0,
        waitTime: 1500
      };
    }
  },
  methods: {
    // 加载初始数据
    async loadInitialData() {
      this.loading = true;
      try {
        // 加载分类数据（从数据库标签表获取）
        await this.loadCategories();
        // 加载文件数据
        await this.loadFilesData();
      } catch (error) {
        console.error('数据加载失败:', error);
        this.$message.error('数据加载失败，请刷新页面重试');
      } finally {
        this.loading = false;
      }
    },

    // 加载分类数据（从source_tag表获取，mark=2, tag=7为主赛道，tag=8为专项赛道）
    async loadCategories() {
      try {
        // 获取主赛道分类
        const mainTrackResponse = await this.axios.datiaoIndex({});
        if (mainTrackResponse.data.code === 200 && mainTrackResponse.data.data) {
          this.mainTrackCategories = mainTrackResponse.data.data.map(item => ({
            id: item.id,
            name: item.name
          }));
          // 设置默认选中"全部"
          this.mainTrackSelectedCategory = 'all';
        } else {
          // 如果接口失败，使用默认数据
          this.mainTrackCategories = [
            { id: 1624, name: '自然科学类学术论文' },
            { id: 1625, name: '科技发明制作A类' },
            { id: 1626, name: '科技发明制作B类' },
            { id: 1627, name: '哲学社会科学类社会调查报告' }
          ];
          this.mainTrackSelectedCategory = 'all';
        }

        // 获取专项赛道分类
        const specialTrackResponse = await this.axios.datiaoIndex1({});
        if (specialTrackResponse.data.code === 200 && specialTrackResponse.data.data) {
          this.specialTrackCategories = specialTrackResponse.data.data.map(item => ({
            id: item.id,
            name: item.name
          }));
          // 设置默认选中"全部"
          this.specialTrackSelectedCategory = 'all';
        } else {
          // 如果接口失败，使用默认数据
          this.specialTrackCategories = [
            { id: 1628, name: '红色专项赛' },
            { id: 1629, name: '"黑科技"专项赛' },
            { id: 1632, name: '"揭榜挂帅"专项赛' },
            { id: 1631, name: '"人工智能+"专项赛' }
          ];
          this.specialTrackSelectedCategory = 'all';
        }
      } catch (error) {
        console.error('加载分类数据失败:', error);
        // 使用默认数据
        this.mainTrackCategories = [
          { id: 1624, name: '自然科学类学术论文' },
          { id: 1625, name: '科技发明制作A类' },
          { id: 1626, name: '科技发明制作B类' },
          { id: 1627, name: '哲学社会科学类社会调查报告' }
        ];
        this.specialTrackCategories = [
          { id: 1628, name: '红色专项赛' },
          { id: 1629, name: '"黑科技"专项赛' },
          { id: 1632, name: '"揭榜挂帅"专项赛' },
          { id: 1631, name: '"人工智能+"专项赛' }
        ];
        this.mainTrackSelectedCategory = 'all';
        this.specialTrackSelectedCategory = 'all';
      }
    },

    // 加载文件数据
    async loadFilesData() {
      // 加载主赛道文件
      if (this.mainTrackSelectedCategory) {
        await this.loadMainTrackFiles();
      } else {
        // 如果没有选中分类，默认选中"全部"
        this.mainTrackSelectedCategory = 'all';
        await this.loadMainTrackFiles();
      }

      // 加载专项赛道文件
      if (this.specialTrackSelectedCategory) {
        await this.loadSpecialTrackFiles();
      } else {
        // 如果没有选中分类，默认选中"全部"
        this.specialTrackSelectedCategory = 'all';
        await this.loadSpecialTrackFiles();
      }
    },

    // 加载主赛道文件列表
    async loadMainTrackFiles() {
      try {
        // 调用 /page 接口，使用 id 参数
        // 如果是"全部"，传入 id: 0；如果是具体分类，传入对应的分类 id
        const id = this.mainTrackSelectedCategory === 'all' ? 0 : this.mainTrackSelectedCategory;
        
        const response = await this.axios.datiaoPage({
          id: id,
          pageNum: this.mainTrackPageNum,
          pageSize: this.pageSize
        });

        if (response.data.code === 200 && response.data.data) {
          this.mainTrackFiles = response.data.data.records || [];
          this.mainTrackTotal = response.data.data.total || 0;
        } else {
          this.mainTrackFiles = [];
          this.mainTrackTotal = 0;
        }
      } catch (error) {
        console.error('加载主赛道文件失败:', error);
        this.mainTrackFiles = [];
        this.mainTrackTotal = 0;
      }
    },

    // 加载专项赛道文件列表
    async loadSpecialTrackFiles() {
      try {
        // 调用 /page1 接口，使用 id 参数
        // 如果是"全部"，传入 id: 0；如果是具体分类，传入对应的分类 id
        const id = this.specialTrackSelectedCategory === 'all' ? 0 : this.specialTrackSelectedCategory;
        
        const response = await this.axios.datiaoPage1({
          id: id,
          pageNum: this.specialTrackPageNum,
          pageSize: this.pageSize
        });

        if (response.data.code === 200 && response.data.data) {
          this.specialTrackFiles = response.data.data.records || [];
          this.specialTrackTotal = response.data.data.total || 0;
        } else {
          this.specialTrackFiles = [];
          this.specialTrackTotal = 0;
        }
      } catch (error) {
        console.error('加载专项赛道文件失败:', error);
        this.specialTrackFiles = [];
        this.specialTrackTotal = 0;
      }
    },

    // 选择主赛道分类
    async selectMainTrackCategory(categoryId) {
      this.mainTrackSelectedCategory = categoryId;
      this.mainTrackPageNum = 1;
      await this.loadMainTrackFiles();
    },

    // 选择专项赛道分类
    async selectSpecialTrackCategory(categoryId) {
      this.specialTrackSelectedCategory = categoryId;
      this.specialTrackPageNum = 1;
      await this.loadSpecialTrackFiles();
    },

    // 获取分类名称
    getCategoryName(categoryId) {
      const allCategories = [...this.mainTrackCategories, ...this.specialTrackCategories];
      const category = allCategories.find(cat => cat.id === categoryId);
      return category ? category.name : '';
    },

    // 处理图片加载错误
    handleImageError(event) {
      const img = event.target;
      const placeholder = document.createElement('div');
      placeholder.className = 'image-placeholder';
      placeholder.innerHTML = '<i class="el-icon-picture-outline"></i>';
      img.parentNode.replaceChild(placeholder, img);
    },

    // 查看文件详情
    viewFile(file) {
      // 跳转到大挑详情页
      const link = this.$router.resolve({
        name: "BigChallengeDetail",
        query: { 
          code: file.code
        }
      });
      window.open(link.href, "_blank");
    },

    // 获取轮播图
    async getSwiperData() {
      try {
        const response = await this.axios.datiaoIndexAd({});
        if (response.data.code === 200 && response.data.data && response.data.data.length > 0) {
          this.ppttrack = response.data.data.map(item => ({
            id: item.id,
            image: item.image,
            type: item.type || 1,
            url: item.url || ''
          }));
        } else {
          // 如果没有轮播图数据，使用默认图片
          this.ppttrack = [
            {
              id: 1,
              image: 'https://static.ibeisai.com/image/20200507/banner2256.jpg',
              type: 1
            },
            {
              id: 2,
              image: 'https://rselect1.oss-cn-beijing.aliyuncs.com/image/20200507/03.png',
              type: 1
            }
          ];
        }
      } catch (error) {
        console.error('获取轮播图失败:', error);
        // 使用默认图片
        this.ppttrack = [
          {
            id: 1,
            image: 'https://static.ibeisai.com/image/20200507/banner2256.jpg',
            type: 1
          },
          {
            id: 2,
            image: 'https://rselect1.oss-cn-beijing.aliyuncs.com/image/20200507/03.png',
            type: 1
          }
        ];
      }
    },

    // 获取用户评价数据
    async getReviewData() {
      try {
        const response = await this.axios.datiaoIndexMsg({});
        if (response.data.code === 200 && response.data.data) {
          this.reviewData1 = response.data.data.s1 || [];
          this.reviewData2 = response.data.data.s2 || [];
          this.$nextTick(() => {
            this.$refs.reviewScroll1 && this.$refs.reviewScroll1.reset();
            this.$refs.reviewScroll2 && this.$refs.reviewScroll2.reset();
          });
        } else {
          // 如果接口失败，使用空数组
          this.reviewData1 = [];
          this.reviewData2 = [];
        }
      } catch (error) {
        console.error('获取用户评价失败:', error);
        // 评价数据加载失败，使用空数组
        this.reviewData1 = [];
        this.reviewData2 = [];
      }
    },

    // 轮播图相关方法
    addUrl(item) {
      // 处理轮播图点击事件
    },

    // 分页处理 - 主赛道
    async handleMainTrackPageChange(page) {
      this.mainTrackPageNum = page;
      await this.loadMainTrackFiles();
    },

    // 分页处理 - 专项赛道
    async handleSpecialTrackPageChange(page) {
      this.specialTrackPageNum = page;
      await this.loadSpecialTrackFiles();
    },

    ...mapMutations(["UP_BOOLE"])
  },

  watch: {
    screenWidth(val) {
      // 屏幕宽度变化处理
    }
  },

  async mounted() {
    this.UP_BOOLE();
    await this.getSwiperData();
    await this.getReviewData();
    await this.loadInitialData();

    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
    };
  }
};
</script>

<style scoped>
.bigchallenge-page {
  min-height: 100vh;
  background: #f5f7fa;
  position: relative;
}

.bigchallenge-page::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 300px;
  background: #ffffff;
  z-index: 0;
}

.bigchallenge-page > div {
  position: relative;
  z-index: 1;
}

/* 轮播图样式 */
.swiper {
  position: relative;
  margin-bottom: 40px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.swiper img {
  width: 100%;
  height: 625px;
  object-fit: cover;
}

.swiperBox .el-carousel__indicators {
  opacity: 0;
}

.swiperBox .el-carousel {
  width: 100%;
  overflow: hidden;
}

.swiperBox .el-carousel__container {
  width: 100%;
  overflow: hidden;
}

.swiperBox .el-carousel__item {
  overflow: hidden;
}

/* 大挑模块标题区域样式 - 简约风格 */
.bigchallenge-title-section {
  max-width: 1400px;
  margin: 40px auto 30px;
  padding: 0 32px;
}

.bigchallenge-title-header {
  text-align: center;
  padding: 40px 32px 32px;
  background: #ffffff;
  border-radius: 0;
  box-shadow: none;
  border: none;
  position: relative;
  overflow: hidden;
  border-bottom: 1px solid #f0f2f5;
}

.title-icon-wrapper {
  margin-bottom: 20px;
}

.title-icon {
  font-size: 48px;
  color: #13a4e6;
  display: inline-block;
  padding: 16px;
  background: #e8f4f8;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  line-height: 48px;
  box-sizing: border-box;
}

.bigchallenge-title-header h2 {
  font-size: 36px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 16px 0;
  letter-spacing: 1px;
  position: relative;
}

.bigchallenge-title-header .title-subtitle {
  font-size: 16px;
  color: #7a8a9a;
  margin: 0 0 24px 0;
  font-weight: 400;
  letter-spacing: 2px;
}

.title-decoration {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 24px;
}

.decoration-line {
  width: 60px;
  height: 2px;
  background: #13a4e6;
}

.decoration-dot {
  width: 8px;
  height: 8px;
  background: #13a4e6;
  border-radius: 50%;
}

/* 大挑模块样式 - 左右分栏布局 */
.bigchallenge-content-wrapper {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 24px 40px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  margin-top: -30px;
  position: relative;
  z-index: 2;
  border: 1px solid #e8eaed;
}

.bigchallenge-modules {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0;
}

.module-section {
  background: #ffffff;
  border-radius: 0;
  box-shadow: none;
  margin-bottom: 0;
  padding: 0;
  overflow: hidden;
  border: none;
  border-bottom: 1px solid #f0f2f5;
}

.module-section:last-child {
  border-bottom: none;
}

.module-header-wrapper {
  background: #fafbfc;
  border-bottom: 1px solid #f0f2f5;
  position: relative;
  padding: 0 32px;
}

.module-header {
  text-align: center;
  padding: 24px 0 16px;
}

.module-title-group {
  display: inline-block;
  position: relative;
}

.module-header h2 {
  font-size: 22px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 4px 0;
}

.module-header p {
  font-size: 11px;
  color: #95a5a6;
  margin: 0;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  font-weight: 400;
}

/* 分类标签样式 - 简约按钮风格 */
.category-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 0 0 16px;
  background: #fafbfc;
  justify-content: center;
  margin: 0 32px;
}

.category-tab {
  padding: 8px 20px;
  background: #ffffff;
  border: 1px solid #e8eaed;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 13px;
  font-weight: 400;
  color: #5f6c7b;
}

.category-tab:hover {
  background: #f0f9ff;
  border-color: #13a4e6;
  color: #13a4e6;
}

.category-tab.active {
  background: #e8f4f8;
  border-color: #13a4e6;
  color: #13a4e6;
  font-weight: 500;
  position: relative;
}

/* 文件网格样式 - 简约卡片风格 */
.files-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin: 24px 32px;
  padding: 0;
}

.file-card {
  background: #ffffff;
  border: 1px solid #f0f2f5;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  position: relative;
}

.file-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: transparent;
  transition: background 0.3s ease;
}

.file-card:hover::before {
  background: #13a4e6;
}

.file-card:hover {
  border-color: #13a4e6;
  box-shadow: 0 4px 12px rgba(19, 164, 230, 0.15);
  transform: translateY(-2px);
  transition: all 0.3s ease;
}

.file-image {
  width: 100%;
  height: 180px;
  overflow: hidden;
  position: relative;
  background: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
}

.file-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #f8f9fa;
}

.image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f1f5f9;
  color: #cbd5e1;
}

.image-placeholder i {
  font-size: 48px;
}

.file-image .ppt_tag-vip {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 36px;
  height: 36px;
  background: url('../../assets/vipimage.png') no-repeat center;
  background-size: contain;
  z-index: 1;
}

.file-info {
  padding: 10px 16px;
}

.file-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 10px;
}

.file-tag {
  font-size: 10px;
  color: #94a3b8;
  background: #f8f9fa;
  padding: 3px 8px;
  border-radius: 10px;
  border: 1px solid #e8eaed;
  transition: all 0.3s ease;
}

.file-card:hover .file-tag {
  background: #e8f4f8;
  border-color: #13a4e6;
  color: #13a4e6;
}

.file-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}

.file-left {
  flex: 1;
  min-width: 0;
}

.file-right {
  flex-shrink: 0;
}

.file-info h3 {
  font-size: 15px;
  font-weight: 500;
  color: #1e293b;
  margin: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  transition: color 0.3s ease;
}

.file-card:hover .file-info h3 {
  color: #13a4e6;
}

.file-stats {
  display: flex;
  gap: 16px;
  align-items: center;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #94a3b8;
  white-space: nowrap;
  transition: color 0.3s ease;
}

.stat-item i {
  font-size: 14px;
  color: #13a4e6;
}

.file-card:hover .stat-item {
  color: #13a4e6;
}


/* 空状态 */
.empty-state {
  text-align: center;
  padding: 80px 20px;
  background: #fafbfc;
  border-radius: 0;
  margin: 0;
}

.empty-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e8eaed;
  border-radius: 50%;
}

.empty-icon i {
  font-size: 40px;
  color: #94a3b8;
}

.empty-state p {
  color: #94a3b8;
  font-size: 14px;
  margin: 0;
  font-weight: 400;
}

/* 分页样式 */
.pagination-container {
  display: flex;
  justify-content: center;
  margin: 0;
  padding: 20px 32px 30px;
  border-top: 1px solid #f0f2f5;
}

/* 用户评价轮播区域样式 - 简约风格 */
.reviews-section {
  background: #ffffff;
  padding: 60px 0;
  margin-top: 30px;
  border-top: 1px solid #f0f2f5;
}

.reviews-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.reviews-header {
  text-align: center;
  margin-bottom: 40px;
}

.reviews-header {
  position: relative;
}

.reviews-header h2 {
  font-size: 26px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 8px 0;
  position: relative;
  display: inline-block;
}

.reviews-header h2::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 50px;
  height: 3px;
  background: #13a4e6;
}

.reviews-header p {
  font-size: 12px;
  color: #95a5a6;
  margin: 0;
  letter-spacing: 2px;
  text-transform: uppercase;
  font-weight: 400;
}

.reviews-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.review-scroll {
  height: 120px;
  overflow: hidden;
  position: relative;
}

.review-scroll ul {
  display: flex;
  align-items: center;
  height: 100%;
}

.review-item {
  display: flex;
  align-items: center;
  padding: 16px 24px;
  background: #fafbfc;
  border-radius: 12px;
  margin-right: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  transition: all 0.25s ease;
  white-space: nowrap;
  min-width: 400px;
  border-left: 3px solid #e8f4f8;
  flex-shrink: 0;
}

.review-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border-left-color: #13a4e6;
}

.review-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 16px;
  flex-shrink: 0;
  border: 2px solid #e8eaed;
}

.review-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.review-content {
  flex: 1;
}

.review-text {
  font-size: 15px;
  color: #475569;
  line-height: 1.5;
  margin-bottom: 6px;
  font-weight: 400;
}

.review-user {
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
}

/* 服务保障区域样式 - 简约风格 */
.itmentBox {
  width: 100%;
  background: #fafbfc;
  border-top: 1px solid #f0f2f5;
  padding: 50px 0;
}

.tment_ul {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  padding: 0 20px;
}

.tment_ul li {
  flex: 1;
  max-width: 350px;
  padding: 40px 30px;
  box-sizing: border-box;
  text-align: center;
  position: relative;
}

.tment_ul li i {
  font-size: 64px;
  line-height: 1;
  height: 88px;
  margin-bottom: 24px;
  color: #13a4e6;
  display: block;
  transition: color 0.3s ease;
  padding: 12px;
  background: #e8f4f8;
  border-radius: 12px;
  width: 105px;
  margin: 10px auto;
  box-sizing: border-box;
}


.decla_title {
  font-size: 18px;
  color: #2c3e50;
  height: 28px;
  line-height: 28px;
  margin-bottom: 12px;
  font-weight: 500;
}

.decla_intro {
  font-size: 14px;
  color: #64748b;
  line-height: 24px;
  font-weight: 400;
}

.tment_ul li::after {
  content: '';
  width: 1px;
  height: 120px;
  display: block;
  background: #e8eaed;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.tment_ul li.last_item::after {
  display: none;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .files-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 18px;
  }
}

@media (max-width: 768px) {
  .bigchallenge-content-wrapper {
    padding: 0 16px 30px;
    margin-top: -20px;
    border-radius: 6px;
  }

  .bigchallenge-title-section {
    margin: 30px auto 20px;
    padding: 0 16px;
  }

  .bigchallenge-title-header {
    padding: 30px 20px 24px;
  }

  .title-icon {
    font-size: 40px;
    width: 70px;
    height: 70px;
    line-height: 40px;
    padding: 14px;
  }

  .bigchallenge-title-header h2 {
    font-size: 22px;
    letter-spacing: 0.5px;
  }

  .bigchallenge-title-header .title-subtitle {
    font-size: 13px;
    letter-spacing: 1.5px;
  }

  .module-section {
    margin-bottom: 0;
  }

  .module-header {
    padding: 20px 20px 12px;
  }

  .module-header h2 {
    font-size: 18px;
  }

  .category-tabs {
    padding: 0 0 12px;
    gap: 6px;
    margin: 0 20px;
  }

  .category-tab {
    padding: 6px 16px;
    font-size: 12px;
  }

  .files-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 14px;
    margin: 20px 20px;
  }

  .file-image {
    height: 140px;
  }

  .swiper img {
    height: 300px;
  }

  .pagination-container {
    margin: 20px 0;
    padding: 20px 0;
  }

  .reviews-section {
    padding: 40px 0;
    margin-top: 40px;
  }

  .reviews-header h2 {
    font-size: 22px;
  }

  .review-item {
    min-width: 300px;
    padding: 14px 20px;
  }

  .review-avatar {
    width: 44px;
    height: 44px;
    margin-right: 14px;
  }

  .review-text {
    font-size: 14px;
  }

  .review-user {
    font-size: 12px;
  }

  .tment_ul {
    flex-direction: column;
    align-items: center;
    gap: 0;
  }

  .tment_ul li {
    width: 100%;
    max-width: 100%;
    padding: 35px 25px;
    margin-bottom: 0;
  }

  .tment_ul li i {
    font-size: 56px;
    height: 56px;
    margin-bottom: 20px;
  }

  .decla_title {
    font-size: 17px;
    margin-bottom: 10px;
  }

  .decla_intro {
    font-size: 13px;
  }

  .tment_ul li::after {
    display: none;
  }
}

@media (max-width: 480px) {
  .bigchallenge-title-section {
    margin: 30px auto 25px;
    padding: 0 12px;
  }

  .bigchallenge-title-header {
    padding: 30px 20px;
  }

  .title-icon {
    font-size: 36px;
    width: 60px;
    height: 60px;
    line-height: 36px;
    padding: 12px;
  }

  .bigchallenge-title-header h2 {
    font-size: 22px;
    letter-spacing: 0;
  }

  .bigchallenge-title-header .title-subtitle {
    font-size: 13px;
    letter-spacing: 1px;
  }

  .files-grid {
    grid-template-columns: 1fr;
    gap: 16px;
    margin: 20px 16px;
  }

  .category-tab {
    padding: 6px 14px;
    font-size: 11px;
  }

  .module-header {
    padding: 20px 16px 14px;
  }

  .module-header h2 {
    font-size: 18px;
  }

  .pagination-container {
    margin: 16px 0;
    padding: 16px 0;
  }
}
</style>

